import { Component, type ErrorInfo, type ReactNode } from 'react';
import SidebarProjectList from '@/components/feature/SidebarProjectList';
import type { SidebarProject } from '@/hooks/useSidebarProjects';

interface Props {
  projects: SidebarProject[];
  loading?: boolean;
  hasResolved?: boolean;
  error?: string | null;
  onRetry?: () => void;
  currentProjectId?: string;
  buildProjectUrl: (projectId: string) => string;
  emptyLabel?: string;
  onProjectClick?: () => void;
}

interface State {
  hasError: boolean;
}

/** Prevent sidebar project list errors from breaking layout or page content. */
export default class SidebarProjectListSafe extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error('[SidebarProjectListSafe] render error', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="ml-2 pl-3 border-l border-white/10 py-1">
          <p className="text-white/45 text-[10px] px-2 py-1">Couldn&apos;t load projects</p>
          <button
            type="button"
            onClick={() => this.setState({ hasError: false })}
            className="mx-2 mt-0.5 px-2 py-1 rounded-md text-[10px] font-semibold text-[#E8621A] hover:bg-white/5 cursor-pointer"
          >
            Retry
          </button>
        </div>
      );
    }

    return <SidebarProjectList {...this.props} />;
  }
}
